import { Node } from '../class';

export class LeaveNode extends Node {
  public icon = 'directions_run';
  public targetId: number[];
  public readonly extraProperties = ['targetId'];
}
